// this is strictly for the frontend,
// engagementBucketRequests must have a unique key for it to work
export enum SocialSeriesNeoFacetKeysEnum {
    mediaTypeFacetGroup = 'MEDIA_TYPE_FACET',
    mediaTypeImpressions = 'MEDIA_TYPE_X_IMPRESSIONS',
    mediaTypeEngagements = 'MEDIA_TYPE_X_ENGAGEMENTS',

    overTimeFacet = 'OVER_TIME',
    impressionsOverTimeFacet = 'IMPRESSIONS_OVER_TIME',
    engagementsOverTimeFacet = 'ENGAGEMENTS_OVER_TIME',
    aveOverTimeFacet = 'AVE_OVER_TIME',

    sentimentFacetGroup = 'SENTIMENT_FACET',
    sentimentByMediaTypeFacetGroup = 'SENTIMENT_X_MEDIA_TYPE_FACET',
    sentimentBySocialTopicFacetGroup = 'SENTIMENT_X_SOCIAL_TOPIC_FACET',
    sentimentOverTimeFacetGroup = 'SENTIMENT_OVER_TIME',

    socialTopicFacetGroup = 'SOCIAL_TOPIC_FACET',
    socialTopicImpressions = 'SOCIAL_TOPIC_X_IMPRESSIONS',
    socialTopicEngagements = 'SOCIAL_TOPIC_X_ENGAGEMENTS',

    totalEngagements = 'TOTAL_ENGAGEMENTS',
    engagementTotalLikes = 'TOTAL_LIKES',
    engagementTotalReply = 'TOTAL_REPLY',
    engagementTotalShare = 'TOTAL_SHARE',
    engagementTotalView = 'TOTAL_VIEW',
    engagementTotalQuotes = 'TOTAL_QUOTES',

    mentionsEngagements = 'MENTION_FACET_X_ENGAGEMENTS',
    mentionsImpressions = 'MENTION_FACET_X_IMPRESSIONS',
}
